/**
 * インターバル時間を日数+時間で扱うカレンダー操作をするクラス
 */
import * as time from '@/libs/time'
import Calendar from './base'

export default class DaysAndCalendar extends Calendar {
  /**
   * 予約開始日時にインターバル時間を確保する
   *
   * @param {Date} d 元の予約開始日時
   * @param {Number} intervalHours インターバル時間
   * @returns {Date} 予約開始日時を返す
   */
  securedBegin (d, intervalHours) {
    // intervalHours を日数と端数に分離する
    const hours = intervalHours % 24
    const days = (intervalHours - hours) / 24

    // days 営業日前の日付を得る
    const dd = this.decrementDays(d, days)
    if (!dd) {
      return time.clone(this._begin)
    }

    // 元の時刻の端数時間前を設定する
    dd.setHours(d.getHours() - hours, d.getMinutes(), 0, 0)

    // 営業時間外かテストする
    const close = this.testClosed(dd, true, false)

    // d が営業中なら dd を返す
    if (!close) {
      return dd
    }

    // 営業時間外の開始日時(d より前の営業中時刻)
    return close.begin
  }

  /**
   * 予約終了日時にインターバル時間を確保する
   *
   * @param {Date} d 元の予約終了日時
   * @param {Number} intervalHours インターバル時間
   * @returns {Date} 予約終了日時を返す
   */
  securedEnd (d, intervalHours) {
    // intervalHours を日数と端数に分離する
    const hours = intervalHours % 24
    const days = (intervalHours - hours) / 24

    // days 営業日前の日付を得る
    const dd = this.incrementDays(d, days)
    if (!dd) {
      return time.clone(this._begin)
    }

    // 元の時刻の端数時間後を設定する
    dd.setHours(d.getHours() + hours, d.getMinutes(), 0, 0)

    // 営業時間外かテストする
    const close = this.testClosed(dd, false, true)

    // d が営業中なら dd を返す
    if (!close) {
      return dd
    }

    // 営業時間外の終了日時(d より後の営業中時刻)
    return close.end
  }

  /**
   * 指定営業日前の日付を得る
   *
   * @param {Date} d 基準になる日時
   * @param {Number} days 営業日数
   * @returns {Date} 指定営業日前の日付を返す
   */
  decrementDays (d, days) {
    let x

    const dd = time.clone(d)
    dd.setHours(0, 0, 0, 0)

    while (days > 0) {
      // 前の営業日を探す
      do {
        dd.setDate(dd.getDate() - 1)
        x = this._dates[time.format('Y-m-d', dd)]
        if (x === undefined) {
          return null
        }
      } while (!x)

      // 残日数を decrement する
      --days
    }
    return dd
  }

  /**
   * 指定営業日後の日付を得る
   *
   * @param {Date} d 基準になる日時
   * @param {Number} days 営業日数
   * @returns {Date} 指定営業日後の日付を返す
   */
  incrementDays (d, days) {
    let x

    const dd = time.clone(d)
    dd.setHours(0, 0, 0, 0)

    while (days > 0) {
      // 次の営業日を探す
      do {
        dd.setDate(dd.getDate() + 1)
        x = this._dates[time.format('Y-m-d', dd)]
        if (x === undefined) {
          return null
        }
      } while (!x)

      // 残日数を decrement する
      --days
    }
    return dd
  }
}
